export enum ServiceDispatchType {
    Service = "S",
    Workorder = "W",
}
